export default __webpack_public_path__ + "static/media/java.1e3a245d.svg";